import type { FocCmdTourStepDef } from './focCmdTourSteps';

/**
 * Position workspace registers scroll helpers for FOC 14.x Command staff tours.
 */
export type FocCmdTourApi = {
  scrollToTour?: (tour: string) => void;
};

let api: Partial<FocCmdTourApi> = {};

export function registerFocCmdTourApi(
  partial: Partial<FocCmdTourApi>
): () => void {
  api = { ...api, ...partial };
  return () => {
    for (const key of Object.keys(partial) as (keyof FocCmdTourApi)[]) {
      if (api[key] === partial[key]) {
        delete api[key];
      }
    }
  };
}

export function getFocCmdTourApi(): Partial<FocCmdTourApi> {
  return api;
}

export function prepareFocCmdStep(def: FocCmdTourStepDef | undefined) {
  if (!def?.tour) return;
  getFocCmdTourApi().scrollToTour?.(def.tour);
}

export function resetFocCmdTourBridgeForTests() {
  api = {};
}
